import { defineStore } from "pinia";
import { useSystemStore } from "./system";
import {
  GET_AGENDA_COUNT_EXTERNO,
  GET_AGENDA_COUNT_INTERNO,
  GET_AGENDA_EXTERNO,
  GET_AGENDA_INTERNO,
  GET_COFRE_CHAVE,
  SET_COFRE_CHAVE,
  GET_GOOGLE_TOKEN,
  GOOGLE_REQUEST,
} from "./lib/apis";

export const useScheduleStore = defineStore("schedule", {
  state: () => ({}),

  getters: {
    // doubleCount (state) {
    //   return state.counter * 2
    // }
  },

  actions: {
    // increment () {
    //   this.counter++
    // }
    getAgendaCountExterno(params) {
      return new Promise((resolve, reject) => {
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post(
            {
              url: GET_AGENDA_COUNT_EXTERNO,
              data: { ...params },
              responseType: "text",
            },
            { root: true }
          )
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getAgendaCountInterno(params) {
      return new Promise((resolve, reject) => {
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post(
            {
              url: GET_AGENDA_COUNT_INTERNO,
              data: { ...params },
              responseType: "text",
            },
            { root: true }
          )
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getAgendaExterno(params) {
      return new Promise((resolve, reject) => {
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post(
            {
              url: GET_AGENDA_EXTERNO,
              data: { ...params },
              responseType: "text",
            },
            { root: true }
          )
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getAgendaInterno(params) {
      return new Promise((resolve, reject) => {
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post(
            {
              url: GET_AGENDA_INTERNO,
              data: { ...params },
              responseType: "text",
            },
            { root: true }
          )
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getCofreChave(params) {
      return new Promise((resolve, reject) => {
        // importa a store do sistema
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post({
            url: GET_COFRE_CHAVE,
            data: { ...params },
            responseType: "text",
          })
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getGoogleToken(params) {
      return new Promise((resolve, reject) => {
        const systemStore = useSystemStore();
        // faz a chamada

        systemStore
          .post(
            {
              url: GET_GOOGLE_TOKEN,
              data: { ...params },
              responseType: "text",
            },
            { root: true }
          )
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    googleRequest(params) {
      return new Promise((resolve, reject) => {
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post(
            { url: GOOGLE_REQUEST, data: { ...params }, responseType: "text" },
            { root: true }
          )
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    setCofreChave(params) {
      return new Promise((resolve, reject) => {
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post(
            { url: SET_COFRE_CHAVE, data: { ...params }, responseType: "text" },
            { root: true }
          )
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  },
  persist: true,
});
